
import {
  Obra
} from '../index';


export class ObraRegistro {
  "ObraId";
  "Registro";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraRegistro`.
   */
  static getModelName() {
    return "ObraRegistro";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraRegistro for dynamic purposes.
  **/
  static factory(data) {
    return new ObraRegistro(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraRegistro',
      plural: 'ObraRegistros',
      path: 'ObraRegistros',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "Registro": {
          name: 'Registro',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraRegistro.js